export enum SettingModuleEnum {
  ap = 'ap',
  mm = 'mm',
  rp = 'rp',
  pix = 'pix',
  bp = 'bp',
  re = 're'
}
